import React from 'react';

import SidebarHeaderCallout from '../SidebarHeaderCallout';
import SidebarHeaderParent from '../SidebarHeaderParent';
import SidebarHeaderPreview from '../SidebarHeaderPreview';
import SidebarHeading from '../SidebarHeading';

interface Props {
    heading?: any;
    parent?: any;
    preview?: any;
    previewImage?: string;
    callout?: any;
    className: string;

    onParentClick?: () => void;
}
export default class SidebarHeader extends React.PureComponent<Props, {}> {
    static defaultProps = {
        className: '',
    };

    render() {
        const { className, parent, preview, previewImage, callout, onParentClick, children } = this.props;

        let parentNode: React.ReactNode;
        if (parent) {
            if (typeof parent === 'string' || (parent.type && parent.type !== SidebarHeaderParent)) {
                parentNode = <SidebarHeaderParent onClick={onParentClick}>{parent}</SidebarHeaderParent>;
            } else {
                parentNode = parent;
            }
        }

        let previewNode: React.ReactNode;
        if (previewImage) {
            previewNode = <SidebarHeaderPreview imageUrl={previewImage} />;
        } else if (preview) {
            if (typeof preview === 'string' || (preview.type && preview.type !== SidebarHeaderPreview)) {
                previewNode = <SidebarHeaderPreview>{preview}</SidebarHeaderPreview>;
            } else {
                previewNode = preview;
            }
        }

        let calloutNode: React.ReactNode;
        if (callout) {
            if (typeof callout === 'string' || (callout.type && callout.type !== SidebarHeaderCallout)) {
                calloutNode = <SidebarHeaderCallout>{callout}</SidebarHeaderCallout>;
            } else {
                calloutNode = callout;
            }
        }

        let classNames: Array<string> = ['ct-sidebar__header'];
        if (className) {
            classNames.push(className);
        }

        return (
            <div className={classNames.join(' ')}>
                {parentNode}
                <div className="ct-sidebar__header-primary">
                    {previewNode}
                    <SidebarHeading>{children}</SidebarHeading>
                    {calloutNode}
                </div>
            </div>
        );
    }
}
